const state = {
  mauticData: {}
};

const getters = {
  userData: state => state.mauticData
};
const actions = {
  saveMauticData({ commit }, data) {
    commit("setMauticData", data);
  }
};
const mutations = {
  setMauticData: (state, data) => (state.mauticData = data)
};

export default {
  state,
  getters,
  actions,
  mutations
};
